<div class="container flex row end-center end-end-xs end-end-m" [ngClass.xl]="'m-xl ' + ngClass" [ngClass.lt-xl]="'m-lg ' + ngClass"
  [ngClass.lt-md]="'m-md ' + ngClass" [ngClass.xs]="'m-xs ' + ngClass">
  <span class="app-bar-contact"><span fxHide.xs>Questions? </span>Give us a call at </span>
  <a href="tel:{{phoneNumber}}">{{ phoneNumber }}</a>
</div>
